import React from 'react';
import Link from '@mui/material/Link';
import loginimage from "../../assets/visibility.png";
import download from "../../assets/download.png";
import { Typography } from "@mui/material";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

import {
  TextField,
  Grid,

  Icon,
} from "@mui/material";

const Skills = () => {
    return(
        <Grid style={{paddingBottom:'7%'}}>
        <Typography
          style={{
            fontWeight: '600',
          letterSpacing:'0.1px',
          fontFamily: 'Rubik',
            color: "#000000",
            marginLeft: '15px',
            marginTop:'2px'
          }}
        >
          Skills
        </Typography>
        <Grid
          style={{
            display: "flex",
            alignItems:'center',
            marginTop:'1%'
          }}
        >
     
            
<div style={{ display:'flex',width:'56%'}}>
  <Typography sx={{backgroundColor:'#F0F8F9',padding:"1px 12px 3px 8px",marginLeft:'3%', fontFamily: 'Rubik',}}>
 Bathroom Fitting
</Typography>
  
  

<Typography style={{backgroundColor:'#F0F8F9',padding:"1px 12px 3px 8px",fontFamily: 'Rubik',marginLeft:'2%'}}>
Toilet Flush
</Typography>



<Typography style={{ backgroundColor:'#F0F8F9',padding:"1px 12px 3px 8px",fontFamily: 'Rubik',marginLeft:'2%'}}>
Kitchen Sink
</Typography>
</div>

        
      
  
          <Typography
            style={{
              fontFamily: 'Rubik',
              fontWeight: 'normal',
              color: "#000000",
            }}
          >
            Attached file
          </Typography>
          <Grid sx={{marginLeft:'2%'}}>
          <Link sx={{ color: '#214E57', marginLeft: '20px', textDecoration: 'none', borderBottom:"1px solid #214E57" }} href="#">Skills proof 1.pdf</Link>
          </Grid>
          <Grid sx={{ display: 'flex', marginLeft:'auto'}}>
            
            <VisibilityOutlinedIcon style={{color:'#0D5C75'}}/>
            
            <FileDownloadOutlinedIcon style={{ marginLeft:'20px',marginRight:'20px',color:'#0D5C75' }} />
          </Grid>
  
        </Grid>
      </Grid>
  
    )
}

export default Skills;
